import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, from, of } from 'rxjs';
import { RestProcedureService } from 'src/app/service/rest/procedure/rest-procedure.service';
import { LanguageRepositoryService } from '../language/language-repository.service';
import { Marker, Procedure, ProcedureOrder, Step } from './procedure.model';
import { ProcedureService } from './procedure.service';
import { catchError, mergeMap, reduce, tap } from 'rxjs/operators';

@Injectable()
export class ProcedureRepositoryService {



  private _procedures: Procedure[] = [];

  proceduresLoaded: boolean = false;
  private _dataSourceProcedures = new MatTableDataSource<Procedure>();


  constructor(private procedureRest: RestProcedureService,
    private procedureService : ProcedureService) { }

  get procedures() : Procedure[] {
    return this._procedures;
  }

  set procedures(data : Procedure[]) {
    this._procedures = data;
  }

  public get dataSourceProcedures() {
    return this._dataSourceProcedures;
  }

  public set dataSourceProcedures(value) {
    this._dataSourceProcedures = value;
  }

  public getProcedures(articleId: number, languageId: string) : Observable<Procedure[]> {
    return this.procedureRest.getProceduresByArticleIdAndLanguageId(articleId, languageId);
  }

  public getProceduresFromArticles(articleIds: number[], languageId: string) : Observable<Procedure[]> {
    return from(articleIds).pipe(
      mergeMap(articleId =>
        this.procedureRest.getProceduresByArticleIdAndLanguageId(articleId, languageId).pipe(
          tap({
            error: err => console.error(`Error for articleId ${articleId}:`, err) // Exception logs
          }),
          catchError(() => of([])) // Ignore exceptions and return an empty array
        )
      ),
      reduce((acc, val) => [...acc, ...val], []) // Merge results into unique array
    )
  }

  orderProcedures(orderArray: ProcedureOrder[]) {
    this.procedureRest.orderProcedures(orderArray).subscribe(result => { }, error => { console.log(error);});
  }

  getProceduresByArticleId(articleId: number) : Observable<Procedure[]> {
    return this.procedureRest.getProceduresByArticleIdAndLanguageId(articleId, 'en');
  }

}
